<div class="panel-heading">
    {{barChartMainLabel}}
</div>
<div class="panel ">
    <div class="panel-body">
        <canvas baseChart id="barChart" [datasets]="barChartData" [labels]="barChartLabel" [options]="barChartOptions"
            [plugins]="barChartPlugins" [chartType]="barChartType"></canvas>
    </div>
</div>